import { useForm } from '@mantine/form';
import { Container, Group } from '@mantine/core';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import { getSitesListbyclientId } from "../../store/actions";
import { useEffect, useState } from "react";
import { onAddnewChangeRequest } from '../../store/actions';
import { fetchAllChangetype } from '../../store/manageSite/actions';
import { validateEmail, validateName } from "../../helpers/common";
import MantineTextInput from "../../components/mantine/textinput";
import MantineSelect from "../../components/mantine/select";
import MantineButton from "../../components/mantine/button";
import MantineCheckbox from "../../components/mantine/checkbox";
import MantineDateSelect from "../../components/mantine/dateinput";
import MantineFileInput from "../../components/mantine/uploadfile";
import MantineTextArea from '../../components/mantine/textarea';

const ChangeRequest = () => {
    const clientId = typeof window !== 'undefined' ? localStorage.getItem('clientId') : null
    const form = useForm({
        initialValues: {
            siteId: null,
            clientId: clientId,
            requestDate: null,
            applicantName: '',
            applicantEmail: '',
            changeTypeId: null,
            changeRequestComment: '',
            uploadDrawings: false,
            commissionCertificate: false,
            manufacturersLiterature: false,
            approveDeclaration: false,
            fileUpload: null,
        },
        validate: {
            siteId: (val) => (val ? null : 'Please Select Site Name'),
            requestDate: (val) => (val ? null : 'Request Date is required'),
            applicantName: validateName,
            applicantEmail: (val: any) => (validateEmail(val)),
            changeTypeId: (val: any) => (val == null || val == 0 ? "Please Select changeType" : null),
            changeRequestComment: (val) => (val.trim().length > 0 ? null : 'Comment is required'),
            fileUpload: (val: File | null) => {
                if (!val) {
                    return 'File Upload is required';
                }                
                return null;
            },

        },
    });
    const dispatch = useDispatch();

    const siteId = useParams();
    const handleResponseChangeForm = (status: any) => {
        if (status === "SUCCESS" || status === "ADD SUCCESS") form.reset();
    }
    const { getAllSite, getchangetype, getsite, } = useSelector((state: any) => ({
        //getAllSite: state?.getsiteData?.getSite,
        getAllSite: state?.getsiteData?.sitelist,
        getchangetype: state?.getManualURL?.Changetypelist,
        getsite: state?.getManualURL?.Manualbysite,
    }));

    useEffect(() => {
        getList();
        dispatch(fetchAllChangetype())
    }, [dispatch]);

    const getList = () => {
        const data = {
            "clientId": clientId,
            "pageNumber": '1',
            "pageSize": '1000',
            "sortColumn": "",
            "sortDirection": "",
            "searchKeyword": searchValue
        }
        dispatch(getSitesListbyclientId(data))
    }

    const [searchValue, setSearchValue] = useState<any>('');
    const siteNames = getAllSite?.map((site: any) => ({
        value: String(site.siteId),
        label: site.siteName
    }));

    const changetypeNames = getchangetype?.map((changetyp: any) => ({ value: String(changetyp.id), label: changetyp.name }));
    const handleSubmit = (values: any) => {
        if (form.isValid()) {
            const dataToSubmit = {
                ...form.values,
            };
            dispatch(onAddnewChangeRequest(dataToSubmit, handleResponseChangeForm));
        }
    };
    return (
        <Container size="xl" my="xl">
            <form onSubmit={form.onSubmit(handleSubmit)} className='flex-row flex'>
                <Group className='flex-col flex-1'>
                    <MantineDateSelect
                        label={<span>Date <span style={{ color: 'red' }}>*</span></span>}
                        placeholder="Date"
                        value={form.values.requestDate}
                        onChange={(value: any) => form.setFieldValue('requestDate', value)}
                        classNames={{ input: 'w-[363px] h-[40px]  bg-white border border-gray-400 rounded-full opacity-100' }}
                        error={form.errors.requestDate}
                    />
                    <MantineTextInput
                        label={<span>Applicant Name <span style={{ color: 'red' }}>*</span></span>}
                        placeholder="Applicant Name"
                        value={form.values.applicantName}
                        onChange={(event: any) => form.setFieldValue('applicantName', event.currentTarget.value)}
                        classNames={{ input: 'w-[363px] h-[40px]  bg-white border border-gray-400 rounded-[40px] opacity-100' }}
                        error={form.errors.applicantName}
                    />

                    <MantineTextInput
                        label={<span>Applicant Email <span style={{ color: 'red' }}>*</span></span>}
                        placeholder="Applicant Email"
                        value={form.values.applicantEmail}
                        onChange={(event: any) => form.setFieldValue('applicantEmail', event.currentTarget.value)}
                        classNames={{ input: 'w-[363px] h-[40px]  bg-white border border-gray-400 rounded-[40px] opacity-100' }}
                        error={form.errors.applicantEmail}
                    />

                    <MantineSelect
                        {...form.getInputProps('siteId')}
                        label={<span>Site Name <span style={{ color: 'red' }}>*</span></span>}
                        placeholder="Select Site Name"
                        data={siteNames}
                        value={form.values.siteId}
                        classNames={{ input: 'w-[363px] h-[40px] bg-white border border-[#B9B9B9] rounded-[40px] opacity-100' }}
                        error={form.errors.siteId}
                    />
                    <MantineSelect
                        label={<span>Change Type <span style={{ color: 'red' }}>*</span></span>}
                        {...form.getInputProps('changeTypeId')}
                        placeholder="Select Change Type"
                        data={changetypeNames}
                        classNames={{ input: 'w-[363px] h-[40px]  bg-white border border-gray-400 rounded-full opacity-100' }}
                        error={form.errors.changeTypeId}
                    />
                </Group>
                <Group className='flex-col flex-1 items-start'>
                    <MantineFileInput
                        withAsterisk
                        label='File Upload'
                        {...form.getInputProps('fileUpload')}
                        placeholder="File Upload"
                        classNames={{ input: 'w-[363px] h-[40px] bg-white border border-gray-400 rounded-full opacity-100 pr-10' }}
                        error={form.errors.fileUpload}
                    />
                    <MantineTextArea
                        label={<span>Comments <span style={{ color: 'red' }}>*</span></span>}
                        placeholder="Comments"
                        value={form.values.changeRequestComment}
                        onChange={(event: any) => form.setFieldValue('changeRequestComment', event.currentTarget.value)}
                        classNames={{ input: 'w-[620px] h-[180px] bg-white border border-gray-400 rounded-[30px] opacity-100' }}
                        style={{ input: { paddingTop: '15px', paddingLeft: '15px' }, }}
                        error={form.errors.changeRequestComment}
                    />

                    <div className="w-full space-y-4">
                        <h3 className="font-Gantari text-lg font-semibold mb-4">Information Checklist</h3>
                        <div className="flex flex-wrap space-x-8">
                            <div className="flex flex-col space-y-4">
                                <MantineCheckbox
                                    label="Updated Drawing"
                                    checked={form.values.uploadDrawings}
                                    onChange={(event: any) => form.setFieldValue('uploadDrawings', event.currentTarget.checked)}
                                    classNames={{ input: 'text-gray-700 font-medium text-[16px] leading-[19px]' }}
                                />
                                <MantineCheckbox
                                    label="Manufacturer Literature"
                                    checked={form.values.manufacturersLiterature}
                                    onChange={(event: any) => form.setFieldValue('manufacturersLiterature', event.currentTarget.checked)}
                                    classNames={{ input: 'text-gray-700 font-medium text-[16px] leading-[19px]' }}
                                />
                            </div>
                            <div className="flex flex-col space-y-4">
                                <MantineCheckbox
                                    label="Commissioning Certificate"
                                    checked={form.values.commissionCertificate}
                                    onChange={(event: any) => form.setFieldValue('commissionCertificate', event.currentTarget.checked)}
                                    classNames={{ input: 'text-gray-700 font-medium text-[16px] leading-[19px]' }}
                                />
                                <MantineCheckbox
                                    label="Approval Declaration"
                                    checked={form.values.approveDeclaration}
                                    onChange={(event: any) => form.setFieldValue('approveDeclaration', event.currentTarget.checked)}
                                    classNames={{ input: 'text-gray-700 font-medium text-[16px] leading-[19px]' }}
                                />
                            </div>
                        </div>
                    </div>
                    <MantineButton
                        type="submit" name={'SUBMIT'}
                        className="w-[140px] h-[4s0px] bg-[#2F7FE2] rounded-[40px] opacity-100 text-sm font-thin text-white mr-3 "
                        style={{ fontFamily: 'Gantari, sans-serif', fontWeight: 'bold', fontSize: '14px', lineHeight: '16px' }}
                    />
                </Group>

            </form>
        </Container>

    );
};
export default ChangeRequest;